import React, { useEffect } from 'react';
import Cookies from 'universal-cookie';
import PropTypes from 'prop-types';

export default function auth(Component) {
  function AuthenticatedComponent(props) {
    const { history, location } = props;
    const cookies = new Cookies();
    useEffect(() => {
      /**
       * When we start handling the session separately, will replace cookie with context.
       */
      if (!cookies.get('sub_token')) {
        history.push('/login');
      }
    }, []);
    if (!cookies.get('sub_token')) {
      history.push('/login?&redirect=' + location.pathname);
    }
    return <Component {...props} />;
  }

  AuthenticatedComponent.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object
  };

  return AuthenticatedComponent;
}
